/**
 * Utility functions for handling filter data structures
 */

/**
 * Creates a structured filter data object from individual arrays
 * @param {Object} data - Object containing individual filter arrays
 * @param {Array} data.categories - Categories array
 * @param {Array} data.locations - Locations array
 * @param {Array} data.tags - Tags array
 * @returns {Object} Structured filter data object
 */
export const createFilterDataObject = ({ categories, locations, tags }) => ({
    categories: categories || [],
    locations: locations || [],
    tags: tags || [],
});

/**
 * Creates a structured filter loading state object from individual loading states
 * @param {Object} loading - Object containing individual loading states
 * @param {boolean} loading.categoriesLoading - Categories loading state
 * @param {boolean} loading.locationsLoading - Locations loading state
 * @param {boolean} loading.tagsLoading - Tags loading state
 * @returns {Object} Structured filter loading state object
 */
export const createFilterLoadingObject = ({
    categoriesLoading,
    locationsLoading,
    tagsLoading,
}) => ({
    categories: categoriesLoading || false,
    locations: locationsLoading || false,
    tags: tagsLoading || false,
});

/**
 * Default filter data structure
 */
export const DEFAULT_FILTER_DATA = {
    categories: [],
    locations: [],
    tags: [],
};

/**
 * Default filter loading structure
 */
export const DEFAULT_FILTER_LOADING = {
    categories: false,
    locations: false,
    tags: false,
};
